<template>
  <section>
    <!--工具条-->
    <AbnormalSendOrderToolbar :buttonList="buttonList" @callFunction="callFunction"></AbnormalSendOrderToolbar>

    <!--列表-->
    <el-table :data="abnormalSendOrderList" highlight-current-row v-loading="listLoading"
      @current-change="selectCurrentRow" style="width: 100%;">
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <el-table-column fixed="left" prop="CustomName" label="客户名称" width="120"></el-table-column>
      <el-table-column fixed="left" prop="cph" label="车牌号" width="100"></el-table-column>
      <el-table-column prop="id" label="发货单ID" width="320" ></el-table-column>
      <el-table-column prop="jbcch" label="搅拌车车号" width="120" ></el-table-column>
      <el-table-column prop="fhdbh" label="发货单编号" width="150" ></el-table-column>
      <el-table-column prop="rwdbh" label="任务单编号" width="150" ></el-table-column>
      <el-table-column prop="sgdw" label="施工单位" width="300" ></el-table-column>
      <el-table-column prop="gcmc" label="工程名称" width="300" ></el-table-column>
      <el-table-column prop="rqsj" label="日期时间" width="180" ></el-table-column>
      <el-table-column prop="sgbw" label="施工部位" width="300" ></el-table-column>
      <el-table-column prop="gddz" label="工地地址" width="300" ></el-table-column>
      <el-table-column prop="jzfs" label="浇筑方式" width="100" ></el-table-column>
      <el-table-column prop="qddj" label="强度等级" width="100" ></el-table-column>
      <el-table-column prop="xsfl" label="销售方量" width="100" ></el-table-column>
      <el-table-column prop="ljxsfl" label="累计销售方量" width="130" ></el-table-column>
      <el-table-column prop="Signature" label="签名" width="300" ></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" width="180" ></el-table-column>
      <el-table-column prop="Ip" label="Ip" width="200" ></el-table-column>
      <el-table-column prop="Result" label="结果" width="800" ></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="Toolbar">
      <el-pagination layout="total, sizes, prev, pager, next" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total" style="float:right;"></el-pagination>
    </el-col>
  </section>
</template>

<script>
import { getAbnormalSendOrderListPage } from "../../api/api";
import { getButtonList, getOperationButtonList } from "../../promissionRouter";
import AbnormalSendOrderToolbar from "../../components/QueryToolbar/AbnormalSendOrderToolbar";

export default {
  components: { AbnormalSendOrderToolbar },
  data() {
    return {
      filters: {
        customerId: "",
      },
      buttonList: [],
      operationButtonList: [],
      abnormalSendOrderList: [], //客户电子围栏经纬度列表
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        customerId: item.customerId,
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item, row) {
      this.currentRow = row;
      this[item.Func].apply(this, item);
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getVehicleInfo();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getAbnormalSendOrder();
    },
    queryAbnormalSendOrder() {
      this.page = 1;
      this.getAbnormalSendOrder();
    },
    //获取异常发货单列表
    getAbnormalSendOrder() {
      let _this = this;
      let para = {
        customerId: _this.filters.customerId,
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getAbnormalSendOrderListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.abnormalSendOrderList = res.data.response.data;
        _this.listLoading = false;
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    this.getAbnormalSendOrder();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped></style>
